import { Confirmation, ToasterService } from '@abp/ng.theme.shared';
import { DestroyRef, WritableSignal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ZnConfirmation } from '@zendra/shared';
import { finalize, Observable } from 'rxjs';

interface RoutineModalDependencies {
  activeModal: NgbActiveModal;
  confirmationService: ZnConfirmation;
  destroyRef: DestroyRef;
  loading: WritableSignal<boolean>;
  toaster: ToasterService;
}

export class ContinuousInventoryRoutineModalWorkflow {
  constructor(private readonly dependencies: RoutineModalDependencies) {}

  submit(request: Observable<{ message?: string | null }>, getSuccessToastLife: () => number): void {
    const { activeModal, destroyRef, loading, toaster } = this.dependencies;
    request
      .pipe(
        takeUntilDestroyed(destroyRef),
        finalize(() => loading.set(false)),
      )
      .subscribe({
        next: result => {
          if (result.message?.trim()) {
            toaster.success(result.message, null, { life: getSuccessToastLife() });
          }
          // Acceptance is not completion: the routine and its email continue in Hangfire.
          activeModal.close();
        },
        error: error => console.error(error),
      });
  }

  dismiss(dirty: boolean, resetSelection: () => void): void {
    const { activeModal, confirmationService, loading } = this.dependencies;
    if (loading()) {
      return;
    }

    if (!dirty) {
      activeModal.dismiss();
      return;
    }

    confirmationService.showCancelConfirmation().subscribe(status => {
      if (status !== Confirmation.Status.confirm) {
        return;
      }

      resetSelection();
      activeModal.dismiss();
    });
  }
}
